import { atheria } from './atheria';
import { cardania } from './cardania';
import { asmar } from './asmar';
import { kyria } from './kyria';
import { iceflows } from './iceflows';
import { puntos } from './puntos';
import { teile } from './teile';
import { raptorSaTori } from './raptorSaTori';
import { world } from './world';
import { isles } from './isles';

export const areas = {
  atheria,
  cardania,
  asmar,
  kyria,
  iceflows,
  puntos,
  teile,
  raptorSaTori,
  world,
  isles,
};
